import $http from '@/api/index'
/**
 *  @description 获取虚拟机所有端口
 * @constructor
 */
export function GetSwitchPortByDevMacOrDevId(flagDevIdOrDevMac, devId, devMac) {
  let getUrl = {
    method: 'GET',
    url: 'DMS/GetDM_SwitchPortByDevMacOrDevId',
    requestType: 2,
  }
  let params = {
    flagDevIdOrDevMac: flagDevIdOrDevMac,
    devId: devId,
    devMac: devMac
  }
  return $http(getUrl, params)
}
/**
 * @description 获取所有虚拟化技术
 * @constructor
 */
export function GetAllVirtualClassify() {
  let getUrl = {
    method: 'GET',
    url: 'DMS/GetAllVirtualClassify',
    requestType: 2,
  }
  let params = {}
  return $http(getUrl, params)
}
/**
 * @description 删除运维对象
 * @constructor
 */
export function DeleteObjectByType(info) {
  let getUrl = {
    method: 'POST',
    url: 'DMS/DeleteObjectByType',
    requestType: 2,
  }
  return $http(getUrl, info)
}
/**
 * @description 根据任务Id获取设备
 * @constructor
 */
function GetTaskDeviceByTaskId(taskId) {
  let getUrl = {
    method: 'GET',
    url: 'task/GetTaskDeviceByTaskId',
    requestType: 2,
  }
  let params = {
    taskId: taskId
  }
  return $http(getUrl, params)
}
/**
 * @description 新增删除设备
 * @constructor
 */
function UpdateTaskDevice(AddDeviceList, DelDeviceList) {
  let getUrl = {
    method: 'POST',
    url: 'task/UpdateTaskDevice',
    requestType: 2,
  }
  let params = {
    AddDeviceList: AddDeviceList,
    DelDeviceList: DelDeviceList
  }
  console.log('UpdateTaskDevice', JSON.stringify(params));
  return $http(getUrl, params)
}

export default {
  GetTaskDeviceByTaskId,
  UpdateTaskDevice
}
